module.exports = __webpack_public_path__ + "img/net-profit-icon.c7c50fa4.svg";